import React from 'react';
import styled from 'styled-components';
import { H1, SectionParent, B1 } from '../../StyledComponents';
import RV from '../../../assets/v2/manage/group-23.svg';
import RC from '../../../assets/v2/manage/group-29.svg';
import RD from '../../../assets/v2/manage/group-34.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Section = styled(SectionParent)`
  background: linear-gradient(to bottom, #f4f6fb 0%, #f4f6fb 50%, #f4f6fb 100%);
  display: grid;
  /* z-index: 0; */
  position: relative;
  @media (max-width: 768px) {
    padding-bottom: 0rem;
  }
  @media (max-width: 700px) {
    padding-bottom: 0rem;
  }
`;

export const PageTitle = styled(H1)`
  color: #5d489e;
  line-height: 1.28;
  justify-self: center;
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 1rem;
  /* font-weight: 600; */
  @media (max-width: 768px) {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  @media (max-width: 550px) {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
  }
`;
const PageSubHeading = styled(B1)`
  color: #1c233c;
  margin-bottom: 3rem;
  text-align: center;
  font-family: 'Nunito Sans', sans-serif;
  display: grid;
  justify-self: center;
  @media (max-width: 1100px) {
    width: 60%;
  }
  @media (max-width: 520px) {
    margin-bottom: 3rem;
    width: 100%;
  }
`;
const PageSubHeadingBottom = styled(H1)`
  color: white;
  background: #39415d;
  text-align: center;
  min-height: 82px;
  margin-bottom: 0rem;
  font-family: 'Nunito Sans', sans-serif;
  display: grid;
  align-content: center;
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: 520px) {
    margin-bottom: 0;
    padding-bottom: 1.5rem;
    font-size: 14px;
  }
  @media (max-width: 400px) {
    padding: 1rem;
  }
`;

const Container = styled.div`
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-left: 20%;
  padding-right: 20%;
  padding-bottom: 5rem;

  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-left: 0%;
    padding-right: 0%;
  }
`;

const Item = styled.div`
  display: grid;
  justify-items: center;

  @media (max-width: 520px) {
    margin-bottom: 3rem;
  }
`;

const ItemImg = styled(LazyLoadImage)`
  height: 92px;
`;

const ItemText = styled(B1)`
  margin-top: 1rem;
`;
export default class RemoteDiagnostics extends React.Component<any, any> {
  render() {
    return (
      <div>
        <Section>
          <PageTitle>Remote Management</PageTitle>
          <PageSubHeading>
            Seamlessly view, control and debug your devices remotely and reduce
            support costs by up to 30%.
          </PageSubHeading>
          <Container>
            <Item>
              <ItemImg src={RV} />
              <ItemText>Remote View</ItemText>
            </Item>
            <Item>
              <ItemImg src={RC} />
              <ItemText>Remote Control</ItemText>
            </Item>
            <Item>
              <ItemImg src={RD} />
              <ItemText>Remote Debug</ItemText>
            </Item>
          </Container>
        </Section>
        <PageSubHeadingBottom>
          Take control of your Android devices in less than 20 seconds
        </PageSubHeadingBottom>
      </div>
    );
  }
}
